export default "__VITE_ASSET__OK0Qlplu__"